<template>
    <div class="authentication-page">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-5 mx-auto">
                    <form action="/">
                        <div class="d-flex flex-column justify-content-center vh-100">
                            <div class="card p-sm-4">
                                <div class="card-body">
                                    <div class="text-center">
                                        <span class="success-check mb-3 mx-auto"><i class="ti ti-check"></i></span>
                                        <h4 class="mb-2">Success</h4>
                                        <p>Your new password has been successfully saved</p>
                                        <div>
                                            <button type="submit" class="btn btn-lg btn-linear-primary w-100">Back to Sign In</button>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <img src="@/assets/img/bg/authentication-bg.png" class="bg-left-top" alt="Img">
                                    <img src="@/assets/img/bg/authentication-bg.png" class="bg-right-bottom" alt="Img">
                                </div>
                            </div>						
                            <div class="p-4 text-center">
                                <p class="mb-0 ">Copyright &copy; 2024 - All Rights Reserved Truelysell</p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>